<router-outlet></router-outlet>

<div *ngIf="(loading && loading.isLoading) | async" class="loading-overlay">
  <div class="text-center">
    <div class="spinner-border text-primary" role="status" style="width:3rem;height:3rem"></div>
    <div class="mt-2">Loading...</div>
  </div>
</div>

<!-- Global Alert/Confirm -->
<app-alert-confirm></app-alert-confirm>
